/*
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-08-30 14:18:02
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-28 14:55:30
 * @FilePath: \ces-vue-serve\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';
import routers from './router';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条样式
import changTitle from '../libs/changTitle';

// import { userLogin } from '@/API/index';
import { userLogin } from '@/API/user/rebateUser';
import store from '../store';

Vue.use(Router);
const RouterConfig = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routers
};
const router = new Router(RouterConfig);
let WhiteList = ['403', '404', 'toLoginPage', 'shutDown', 'rjAuthLoginPage', 'changeUser', 'changeChannel'];
router.beforeEach(async (to, from, next) => {
  // 路由跳转前拦截
  NProgress.start();
  if (WhiteList.indexOf(to.name) >= 0) {
    next();
    return;
  }
  if (to.query.loginFrom) {
    localStorage.setItem('loginFrom', to.query.loginFrom || '');
  }
  if (to.path.indexOf('login') !== -1) {
    let params = { ticket: to.query.ticket };

    let str = Object.keys(to.query).find(mk => mk.includes('chiefReturnbPay'));
    if (str) {
      params.route = encodeURIComponent(str.replace('route=', ''));
    }
    var res = await userLogin(params);

    if (res.status === '200') {
      localStorage.setItem('sidLogin', JSON.stringify(res.data.sidLogin));
      if (str) {
        next(`chiefReturnbPay?${str.replace('route=chiefReturnbPay&', '')}`);
        return;
      } else {
        next();
      }
    } else {
      next('/toLoginPage');
      return;
    }
  };
  // if (!localStorage.getItem('sidLogin')?.length) return;
  try {
    let user = await store.dispatch('getuser');
    let power = isPower(to, user);
    if (power && to.name !== 'orderLayout') {
      next('/403');
      return;
    } else {
      if (to.path !== '/login') {
        next();
      } else {
        next('/');
      }
    }

    if (to.name === 'ChiefOrderList' && user.isDistributors === 1) {
      next('/DistributorOrderList');
    }

    if (to.name === 'DistributorOrderList' && user.isDistributors === 2) {
      next('/ChiefOrderList');
    }
  } catch (error) {
    if (error.message === 'noList') {
      next('/403');
      return;
    }
    if (error.message.substring(0, 3) === '302') {
      window.location.href = error.message.substring(4, error.message.length);
    }
    if (error.message === 'noUser') {
      next('/toLoginPage');
    } else {
      // next('/toLoginPage');
      next();
    }
  }
});
router.afterEach((to) => {
  // 路由跳转后
  if (to.meta.title) {
    changTitle(to.meta.title, process.env.BASE_URL);
  }
  NProgress.done(); // 结束Progress
});

function isPower (router, user) {
  // 强制放行的白名单：不受权限码控制
  // const forceShowList = ['orderPersionContractList', 'orderInternationPersionContractList', 'creditTransfer', 'settlementQuery', 'invoiceNoticeManagement', 'orderClerkWireTransferAllocation'];
  // if (forceShowList.indexOf(router.name) >= 0) {
  //   return false;
  // }
  let responseName = JSON.parse(localStorage.getItem('childrenItem'));
  // 对比两个数组 删选 订单全流程需要控制的数据
  let list = responseName.filter(items => {
    if (!user.perssimionCodeList.includes(items)) return items;
  });
  return list.indexOf(router.name) >= 0;
}

export default router;
